export { default } from './ListItemSecondaryAction';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ListItemSecondaryAction/index.js
// module id = 341
// module chunks = 0